export const SAFE_BORROW_LIMIT_PERCENTAGE = 80;
